<h2>Rechnungsadresse</h2>

<p>
  Geben Sie bitte die Adresse des Rechnungsempfängers an. Die mit einem Stern markierten Felder sind Pflichtfelder.
</p>

<form id="billingAddressForm" class="twoColumnForm" #f="ngForm">

  <output id="organizationName">
    {{organization.organizationName}}
  </output>
  <div></div>

  <input id="billingAddressLine1" name="billingAddressLine1" placeholder="Adresse 1 *" type="text" maxlength="100" required [(ngModel)]="organization.billingAddressLine1"/>
  <input id="billingAddressLine2" name="billingAddressLine2" placeholder="Adresse 2" type="text" maxlength="100" [(ngModel)]="organization.billingAddressLine2"/>

  <input id="billingPostalCode" name="billingPostalCode" placeholder="PLZ *" type="text" maxlength="100" required [(ngModel)]="organization.billingPostalCode"/>
  <input id="billingCity" name="billingCity" placeholder="Ort *" type="text" maxlength="100" required [(ngModel)]="organization.billingCity"/>

  <select id="billingCountryCode" name="billingCountryCode" required [(ngModel)]="organization.billingCountryCode">
    <option *ngFor="let country of availableCountries" [value]="country.code">{{country.name}}</option>
  </select>
  <div></div>

  <input id="billingEmail" name="billingEmail" placeholder="Email *" type="email" maxlength="100" email required [(ngModel)]="organization.billingEmail"/>
  <input id="billingPhone" name="billingPhone" placeholder="Telefon *" type="tel" pattern="[0+][0-9][-0-9 /()]+" maxlength="100" required title="Nummer muss mit + oder 0 beginnen" [(ngModel)]="organization.billingPhone"/>

</form>

<div class="buttonRow">
  <button (click)="appController.previous()">Zurück</button>
  <button (click)="appController.next(f)">Weiter</button>
</div>
